<template>
  <div :class="isDetail?'detail-info': 'edit-info'">
  <!--<component :is="active" :detail="detail" :is-detail="isDetail"></component>-->
        <userInfoChange
          v-if="changeType == '1'"
          ref="user"
          :is-detail="isDetail"
          @setAuthFileStatus="setAuthFileStatus"
          :detail="detail">
        </userInfoChange>
        <company-info-change
        v-if="changeType == '1'"
        ref="company"
        @saveInfo="saveInfo"
        @setAuthFileStatus="setAuthFileStatus"
        :is-detail="isDetail"
        :detail="detail">
      </company-info-change>
        <file-info-change
          ref="file"
          :is-detail="isDetail"
          class="file-card"
          @saveInfo="saveInfo"
          @refreshList="back"
          :auth-file-status="authFileStatus"
          :detail="detail">
        </file-info-change>
  <div class="tc mt50">
        <el-button v-if="!isDetail"  type="primary" size="medium" class="mr10 fsp-btn-blue-bg" @click="showConfirmDialog">提交审核</el-button>
        <el-button v-if="!isDetail && workflowStatus!='3'"  type="primary" size="medium" class="mr10 fsp-btn-blue-bg" @click="saveAndBack">保存</el-button>
        <el-button  size="medium" class="back-button" @click="back">返回</el-button>
    </div>
    <el-dialog
        :visible.sync="showSubmitConfirmDialog"
        class="DLMessageBox"
        title="短信确认"
        styel="z-index: 1000"
        :close-on-click-modal="false"
        modal
        center
        >
        <div class="sms-info">
            {{smsText}}
        </div>          
        <div class="sms-vcode">
          <el-form :model="smsFormModel" ref="smsForm" :rules="rules" label-width="100px">
            <el-form-item prop="smsCode" label="短信验证码:">
              <el-input placeholder="请输入验证码" v-model="smsFormModel.smsCode" style="width:150px;" maxlength="6"></el-input>
            </el-form-item>
          </el-form>
          <vcode-button  :mobile="detail.origin.userInfo.phoneNo" msgtype='changeInfo' @click="getCode"></vcode-button>
        </div>
        <span slot="footer">
          <el-button type="primary" class="fsp-btn-blue-bg mr10" size="medium" @click="doSubmit">确定</el-button>
          <el-button  class="back-button" size="medium" @click="closeSmsDialog">取消</el-button>
        </span>
    </el-dialog>
    <workflow-table v-if="$route.query.business_id" :business-id="$route.query.business_id"></workflow-table>
      <agreement
        :hideAgreeText="true"
        :info="agreementInfo"
        @getStatus="getStatus"
        @getVersion="readAgreeCallback"
        ref="agreement"
        :checked="checked">
      </agreement>

  </div>
</template>
<script>
import UserInfoChange from './UserInfoChange';
import CompanyInfoChange from './CompanyInfoChange';
import FileInfoChange from './FileInfoChange';
import VcodeButton from '@/views/authentication/components/VcodeButton.vue';
import workflowTable from '@/views/userManagement/components/WorkflowTable.vue';
import { Loading } from "element-ui";
import _ from "lodash";
import Agreement from '@/components/public/Element/agreement3';
import {
  saveComInfoChange,
  submitComInfoChange,
  modifyComInfoChange
} from '@/http/usercenter.js'
    export default {
    name: 'infoChange',
    props: ["type",'detail',"changeType"],
    components: {UserInfoChange,CompanyInfoChange,FileInfoChange,VcodeButton, workflowTable, Agreement},
    data() {
      return {
        isDetail: this.type=='detail',
        active:this.changeType=='1' ?'user': 'file',
        userInfo:{},

        companyInfo:{},
        fileInfo:{},
        companyAuthFileStatus: {
          authFile: {visible: false},
          certFaceId: {visible: false},
          businessLicenceId: {visible: this.changeType=='2' ? true : false},
          lawCertFaceId: { visible:false },
          allowChangeNoticeId: { visible: false },
          issueAgreement: { visible: this.changeType=='3' ? true : false }
        },
        userAuthFileStatus: {
          authFile: {visible: false},
          certFaceId: {visible: false},
        },
        showSubmitConfirmDialog: false,
        bizId:'',
        smsText:'',
        smsFormModel: {
          smsCode:''
        },
        workflowStatus: this.detail.workflowStatus,
        rules:{
          smsCode:[
            { validator: this.checkSmsCode, trigger: 'blur'}
          ],
        },
        checked: true,
        agreementInfo:{
          agreementNos: [
            "digital"
          ]
        },
        authApplyNo: this.detail.authApplyNo
      }
    },
    mounted() {
    },
    computed: {
      authFileStatus: function() {
        console.log("authFileStatus");
        return {
          authFile: { visible: (this.userAuthFileStatus.authFile.visible || this.companyAuthFileStatus.authFile.visible) && this.changeType == '1' },
          //authFile: { visible: this.userAuthFileStatus.authFile.visible },
          certFaceId: { visible: (this.userAuthFileStatus.certFaceId.visible || this.companyAuthFileStatus.certFaceId.visible) && this.changeType == '1' },
          //certFaceId: { visible: this.userAuthFileStatus.certFaceId.visible },
          businessLicenceId:{ visible: this.companyAuthFileStatus.businessLicenceId.visible && this.changeType != '3'},
          lawCertFaceId:{ visible: this.companyAuthFileStatus.lawCertFaceId.visible && this.changeType == '1' },
          allowChangeNoticeId: {visible: this.companyAuthFileStatus.allowChangeNoticeId.visible && this.changeType == '1'},
          issueAgreement: {visible: this.companyAuthFileStatus.issueAgreement.visible && this.changeType == '3'}
        };
      },
      hasAnyChanged: function() {
        let hasAnyChange = false;
        const userCard = this.$refs.user;
        const companyCard = this.$refs.company;
        if(userCard && companyCard) {
          hasAnyChange = userCard.hasAnyChanged || companyCard.hasAnyChanged;
        }
        if(!hasAnyChange) {
          hasAnyChange = this.authFileStatus.authFile.visible ||
                         this.authFileStatus.certFaceId.visible ||
                         this.authFileStatus.businessLicenceId.visible ||
                         this.authFileStatus.lawCertFaceId.visible || 
                         this.authFileStatus.allowChangeNoticeId.visible ;
        }

        return hasAnyChange;
      }
    },
    methods: {
      /*
      changeTab(tab){
        this.active = tab;
        //debugger
        if(this.$refs['file']) {
          this.$refs['file'].authFileStatusObj = this.authFileStatus;
          //debugger
          this.$refs['file'].getAuthFileTableData();
        }
      },
      */
      back(){
        if (this.$route.query.business_id) { // 待办进来的
          this.$router.back();
        } else {
          if(this.$route.query.changeType) {
            let urlSeq = window.location.href.split("?");
            if(urlSeq && urlSeq.length) {
              window.location.assign(urlSeq[0]);
            }
          }

          window.location.reload();
          //this.$emit('showList');
        }
      },
      getCode(data) {
        const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
        const smsPhoneNo = currentUser.phoneNo;
        this.smsText = `已向您的手机${smsPhoneNo.length>=11 ? `${smsPhoneNo.substring(0,3)}****${smsPhoneNo.substring(7,11)}`: smsPhoneNo}发送验证码，用于信息变更申请前的确认，请注意查收短信`;
        if (!data) {
          // this.$message.error(data.msg);
        } else {
          this.bizId = data.data;
        }
      },
      showConfirmDialog() {
        if(!this.checkAllInput()) {
          return ;
        };
        this.doAllFillInfo();
        //debugger
        const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
        const smsPhoneNo = currentUser.phoneNo;
        let companyInfo = JSON.parse(sessionStorage.getItem("company"));
        this.smsText = `点击获取验证码将向你的手机${smsPhoneNo.length>=11 ? `${smsPhoneNo.substring(0,3)}****${smsPhoneNo.substring(7,11)}`: smsPhoneNo.phoneNo}发送验证码，以确认本次申请`;
        if(this.checkAgreement(companyInfo.companyRole)) {
          this.showSubmitConfirmDialog = true;
        }     
      },
      async doSubmit() {
        if(!this.bizId){
          this.$message.error("请点击获取验证码");
          return false
        };
      //校验验证码
      const smsForm = this.$refs.smsForm;
       if(smsForm) {
         smsForm.validate((valid) => {
           if(!valid) {
             return false;
           }
         });
       }

        const _this = this;
        let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
        let companyInfo = JSON.parse(sessionStorage.getItem("company"));
        const reqData = {
          "companyNo": companyInfo.companyNo,	
          "userNo": currentUser.userNo,
          "userInfo": _this.userInfo,
          "companyInfo":_this.companyInfo ,
          "authFiles": _this.fileInfo,
          "authType": '2', // 信息变更写死
          "bizId": this.bizId,
        };
        //debugger
        this.syncAuthFileData(reqData.authFiles, reqData.userInfo, reqData.companyInfo);

        let loadingInstance = Loading.service({
              lock: true,
              text: 'Loading',
              fullscreen: true,
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        //this.authApplyNo = this.detail.authApplyNo;
        this.showSubmitConfirmDialog = false;
        if(!this.authApplyNo || this.authApplyNo == '0') {
          _this.doSave().then(resp => {
            if (resp.ret == 0) {
              reqData.authApplyNo = resp.data.authApplyNo;
              reqData.smsCode = this.smsFormModel.smsCode;
              this.authApplyNo = resp.data.authApplyNo;
              this.detail.authApplyNo = resp.data.authApplyNo;;
              submitComInfoChange(reqData).then(res => {
                if(res.ret == 0) {
                  loadingInstance.close();
                  //可以更新整个页面的状态
                  this.authApplyNo = "";
                  this.back();
                  //_this.$emit('showList');
                } else {
                  loadingInstance.close();
                  // _this.$message.error(res.msg);
                }
              }).catch((ex) => {
                loadingInstance.close();
              });
            } else {
              // _this.$message.error(resp.msg);
              loadingInstance.close();
            }
          });
        } else {
              reqData.authApplyNo = this.authApplyNo;
              reqData.smsCode = this.smsFormModel.smsCode;
              submitComInfoChange(reqData).then(res => {
                if(res.ret == 0) {
                  loadingInstance.close();
                  this.authApplyNo = "";
                  this.back();
                  //_this.$emit('showList');
                } else {
                  loadingInstance.close();
                  // _this.$message.error(res.msg);
                }
              });
        }
      },
      async doSave() {
        // debugger
        let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
        let companyInfo = JSON.parse(sessionStorage.getItem("company"));
        const reqData = {
        "companyNo": companyInfo.companyNo,	
        "userNo": currentUser.userNo,
        "userInfo": this.userInfo,
        "companyInfo":this.companyInfo ,
        "authFiles": this.fileInfo,
        "authType": '2' // 信息变更写死
        };

        //debugger
        this.syncAuthFileData(reqData.authFiles, reqData.userInfo, reqData.companyInfo);
        if(!this.detail.authApplyNo || this.detail.authApplyNo == '0') {
          return await saveComInfoChange(reqData);
        } else {
          reqData.authApplyNo = this.detail.authApplyNo;
          return await modifyComInfoChange(reqData);
        }

      },
      saveAndBack() {
        if(!this.checkAllInput()) {
          return ;
        };
        this.doAllFillInfo();
        let _this = this;
        let loadingInstance = Loading.service({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
        });
        _this.doSave().then(resp => {
          if(resp.ret == 0) {
            loadingInstance.close();
            _this.back();
          } else {
            loadingInstance.close();
            // _this.$message.error("保存失败");
          }
        }).catch(ex => {
          loadingInstance.close();
          // _this.$message.error(ex);
        })
      },
      saveInfo(type,data){
        //debugger
        if(type =='userInfo'){
          this.userInfo = Object.assign({},this.userInfo,data);
        }
        if(type =='companyInfo'){
          this.companyInfo = Object.assign({},this.companyInfo,data);
        }
        if(type =='fileInfo'){
          this.fileInfo = Object.assign(this.fileInfo, data);  
        }
      },
    syncAuthFileData(authFiles, userInfo, companyInfo) {
      //debugger
      if(authFiles) {
        if(!userInfo["userAuthFiles"]) {
          userInfo["userAuthFiles"] = {};
        }

        if(!companyInfo["companyAuthFiles"]) {
          companyInfo["companyAuthFiles"] = {};
        }

        if(authFiles["authFile"]) {
          userInfo["userAuthFiles"].authFile = authFiles["authFile"];
        }

        if(authFiles["certFaceId"]) {
          userInfo["userAuthFiles"].certFaceId = authFiles["certFaceId"];
        }

        if(authFiles["businessLicenceId"]) {
          companyInfo["companyAuthFiles"].businessLicenceId = authFiles["businessLicenceId"];
        }

        if(authFiles["lawCertFaceId"]) {
          companyInfo["companyAuthFiles"].lawCertFaceId = authFiles["lawCertFaceId"];
        }

        if(authFiles["allowChangeNoticeId"]) {
          companyInfo["companyAuthFiles"].allowChangeNoticeId = authFiles["allowChangeNoticeId"];          
        }

        
        if(authFiles["issueAgreement"]) {
          companyInfo["companyAuthFiles"].issueAgreement = authFiles["issueAgreement"];          
        }
      }
    },
    doAllFillInfo() {
      //debugger
      if(this.$refs['user']) {
        this.$refs['user'].saveFillInfo();
      };
      if(this.$refs['company']) {
        this.$refs['company'].saveFillInfo();
      };
      if(this.$refs['file']) {
        this.$refs['file'].saveFillInfo();
      }
    },
    checkAllInput() {
      let userInputCheck = true
      let companyInputCheck = true
      let fileUploadCheck = true

      const userCard = this.$refs.user;
      const companyCard = this.$refs.company;
      const fileCard = this.$refs.file;
      if(userCard) {
        userInputCheck = userCard.inputValidate();
      }

      if(companyCard) {
        companyInputCheck = companyCard.inputValidate();
      }

      if(fileCard) {
        fileUploadCheck = fileCard.inputValidate();
      }
      return userInputCheck && companyInputCheck && fileUploadCheck;
    },
    setAuthFileStatus(authFileStatusObj) {
      //debugger
        this.authFileStatus = {
          authFile: {visible: this.authFileStatus.authFile.visible || authFileStatusObj.authFile.visible },
          certFaceId: {visible: this.authFileStatus.certFaceId.visible || authFileStatusObj.certFaceId.visible },
          businessLicenceId: {visible: this.authFileStatus.businessLicenceId.visible || authFileStatusObj.businessLicenceId.visible },
          lawCertFaceId:{visible: this.authFileStatus.lawCertFaceId.visible || authFileStatusObj.lawCertFaceId.visible },
          allowChangeNoticeId:{visible: this.authFileStatus.allowChangeNoticeId.visible || authFileStatusObj.allowChangeNoticeId.visible },
          issueAgreement:{visible: this.authFileStatus.issueAgreement.visible || authFileStatusObj.issueAgreement.visible }
        };
      },
      checkOrganizer(checked) {
        if(this.$refs['company'] && this.$refs['user']) {
          if(checked) {
            this.$refs['company'].companyInfoCheckStatus["lawCertNo"].checked = true;
            this.$refs['company'].companyInfoCheckStatus["lawCertNo"].checkDisabled = false;
            this.$refs['company'].companyInfoCheckStatus["lawCertType"].checked = true;
            this.$refs['company'].companyInfoCheckStatus["lawCertType"].checkDisabled = false;
            this.$refs['company'].companyInfoCheckStatus["organizerName"].checked = true;
            this.$refs['company'].companyInfoCheckStatus["organizerName"].checkDisabled = false;
            //console.log(this.tableDataComp);
            this.$refs['company'].tableDataComp[4].changeto = this.$refs['user'].tableData[0].changeto;
            this.$refs['company'].tableDataComp[5].changeto = this.$refs['user'].tableData[1].changeto;
            this.$refs['company'].tableDataComp[6].changeto = this.$refs['user'].tableData[2].changeto;
            //console.log(this.tableDataComp);
          } else {
            this.$refs['company'].companyInfoCheckStatus["lawCertNo"].checked = false;
            this.$refs['company'].companyInfoCheckStatus["lawCertNo"].checkDisabled = false;
            this.$refs['company'].companyInfoCheckStatus["lawCertType"].checked = false;
            this.$refs['company'].companyInfoCheckStatus["lawCertType"].checkDisabled = false;
            this.$refs['company'].companyInfoCheckStatus["organizerName"].checked = false;
            this.$refs['company'].companyInfoCheckStatus["organizerName"].checkDisabled = false;
            this.$refs['company'].tableDataComp[4].changeTo = this.detail.origin.companyInfo.organizerName;
            this.$refs['company'].tableDataComp[5].changeTo = this.detail.origin.companyInfo.lawCertType;
            this.$refs['company'].tableDataComp[6].changeTo = this.detail.origin.companyInfo.lawCertNo;

          //console.log(this.tableDataComp);
          }

          this.$refs['company'].checkCompanyInfo();
        }
      },
      checkSmsCode(rule, value, callback) {
        //debugger
        if(!this.smsFormModel.smsCode) {
          return callback(new Error("请输入验证码"));
        }
        //let reg = /^\d{6}$/;
        if(this.smsFormModel.smsCode.length > 6) {
          return callback(new Error("请输入最多6位验证码"));
        }
        callback();
      },
      checkAgreement(companyRole) {
        if(companyRole != 'finance' && this.companyInfo.companyName.trim() != this.detail.origin.companyInfo.companyName.trim()) {
          this.$refs["agreement"].clickAgreement(true);
                  return false;
        }
        return true;
      },
      readAgreeCallback(callback) {
        const _this = this;
        callback(()=>{
          _this.showSubmitConfirmDialog = true;
        });
      },
      getStatus(val){
        this.checked = val
      },
      closeSmsDialog() {
        this.smsFormModel.smsCode = "";
        this.showSubmitConfirmDialog = false;
      }
    },
    created(){
      if(!this.detail.changeto){
        this.detail.changeto = this.detail.origin
      }
      this.userInfo = this.detail.changeto.userInfo;
      this.companyInfo = this.detail.changeto.companyInfo;
      this.fileInfo = this.detail.changeto.authFiles;
      /*
      if(this.$parent.changeType == 2){
        // if(this.changeType==1){
        //   this.$$refs.infoChange = "";
        // }
        // if(this.changeType==2){
          this.changeTab('file')
        // }
      }
      */
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style  lang="less" scoped>
 .detail-info {
  /deep/ .el-table {
    thead {
      th {
        background-color: rgb(231, 229, 229);
        font-weight: bold;
      }
    }
    tbody {
      tr td:nth-child(1){
        text-align: right;
      }
      tr td:nth-child(2){
        text-align: left;
      }
    }
  }
}

.edit-info{
  /deep/ .el-table {
    thead {
      th {
        background-color: #EBF3FE;
        font-weight: bold;
      }
    }
    tbody {
      tr td:nth-child(2){
        text-align: right;
      }
    }
  }
}

  .ml20{
    margin-left: 20px;
  }
  .tc{
   text-align: center;
  }
  /deep/ .el-dialog {
    border-radius: 12px;
    width: 420px;
    .el-dialog__header {
      text-align: left;
    }
    .el-dialog__body {
      display: block;
      padding: 0 20px 0 20px;
      .sms-title {
        margin-bottom: 10px;
      }
      .sms-vcode {
        margin-top: 10px;
        margin-left: 5px;
        display: flex;
        .vcode {
          border: 0;
          padding: 0;
          font-size: 14px;
        }
      }
      .sms-info {
        padding-top:10px;
        padding-bottom:10px;
        margin-left:5px;
      }
    }
    .el-dialog__footer {
      .el-button {
        //width: 14px;
        //height: 14px;
        height: 36px;
        line-height: 36px;
        padding: 0 20px;
        margin-right: 20px;
      }
      .back-button {
        border-color: #1b5bbf;
        background-color: #FFF;
        color: #606266;
        margin-right: 0;
      }
    }
  }
  /deep/ .mr10{
    margin-right: 10px;
  }
  /deep/ .btn-disabled {
    background-color: gray;
  }
  .mt50{
    margin-top: 50px;
  }
  /deep/ .error-msg {
    color: red ;
  }
  /deep/ .loading-block {
    z-index: 2022;
  }
  .fsp-btn-blue-bg {
   background-color: #1b5bbf;
 }
 .back-button {
   border-color: #1b5bbf;
 }
</style>

